module.exports = __webpack_public_path__ + "static/img/Temilayo-academy.22f2822.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Temilayo-academy.jpg
// module id = pCk5
// module chunks = 1